import { Component, OnInit, Input, Injector, ViewChild } from '@angular/core';
import { CorreiosService } from '@app/shared/common/correios/correios.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NgForm } from '@angular/forms';
import { AppUserAddressDtoType } from '@shared/AppEnums';

@Component({
  moduleId: module.id,
  selector: 'address',
  templateUrl: './address.component.html',
  exportAs: 'addressComponent'
})
export class AddressComponent extends AppComponentBase implements OnInit {

  appUserAddressDtoType = AppUserAddressDtoType

  @Input("address") _address: any[];
  @Input("addressDto") AddressDto;
  @ViewChild('addressForm') public addressForm: NgForm;

  public address: any;
  public brazilStates: any[] = CorreiosService.loadBrazilStates();
  public countries: any[] = CorreiosService.loadCountries();
  public citiesFromState: any[] = [];

  constructor(
    private _correiosService: CorreiosService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.address = this._address;
    this.loadCitiesFromState();
  }

  loadCitiesFromState() {
    if (this.isBrasil()) {
      this._correiosService.loadCities(this.address.stateAbbreviation)
        .then(cities => {
          this.citiesFromState = cities;
        });
    }
  };

  loadCities() {

    let stateAbbreviation = this.address.stateAbbreviation;

    if (this.isBrasil()) {
      this._correiosService.loadCities(stateAbbreviation)
        .then(cities => {

          this.citiesFromState = cities;
          this.setValueStateName();
        });
    }
    else
      this.address.stateName = stateAbbreviation;
  }

  clearStateAndCity() {
    this.address.stateName = "";
    this.address.stateAbbreviation = "";
    this.address.city = "";
    this.address.zipCode = "";
  }

  setValueStateName() {

    this.brazilStates.forEach(state => {
      if (state.abbreviation == this.address.stateAbbreviation) {
        this.address.stateName = state.name;
      }
    });
  }

  searchZipCode() {

    let zipCode = this.address.zipCode;

    if (zipCode && zipCode.length >= 8) {

      this._correiosService.searchByPostalCode(zipCode).then(result => {

        let data = result[0];

        if (!!data) {
          this.address.city = data.Municipio.toUpperCase();
          this.address.complement = data.Complemento.toUpperCase();
          this.address.district = data.Bairro.toUpperCase();
          this.address.logradour = data.Logradouro.toUpperCase();
          this.address.stateAbbreviation = data.Estado.toUpperCase();
          this.address.stateName = data.Estado.toUpperCase();
          this.address.countryName = 'BRASIL';
        }

        this.loadCities();
      });
    }
  };

  isBrasil(): boolean {
    return this.address.countryName == 'BRASIL';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/common/addresses/address/address.component.ts